<template>
  <div class="view-message">
    <v-container>
      <div class="header">DIGI PAD</div>
      <div class="content">
        <div v-if="messageCode == 'INCOMPATIBLE_DEVICE'">
          This application is only compatible with tablets<br /><br />
          <b>Device info</b><br />
          Model is {{ deviceMode }}<br />
          Resolution is {{ deviceWidth }} / {{ deviceHeight }}<br />
          Minimum resolution is 600/600
        </div>
        <div v-else-if="messageText">
          {{ messageText }}
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      messageCode: undefined,
      messageText: undefined,
    };
  },

  computed: {
    deviceMode() {
      return this.$store.state.deviceInfo?.model;
    },

    deviceWidth() {
      return window.innerWidth;
    },

    deviceHeight() {
      return window.innerHeight;
    },
  },

  activated() {
    console.log("View/Message activated", this.$route.params);

    this.messageCode = this.$route.params.messageCode;
    this.messageText = this.$route.params.messageText;

    if (!this.messageCode && !this.messageText) {
      if (this.$store.state.deviceInfo?.model !== "iPad" && (this.deviceWidth < 600 || this.deviceHeight < 600))
        this.messageCode = "INCOMPATIBLE_DEVICE";
    }
  },
};
</script>

<style lang="scss" scoped>
.view-message {
  .container {
    .header {
      color: var(--v-primary-base);
      text-align: center;
      font-size: 1.5em;
    }

    .content {
      height: calc(100vh - 48px - 48px);
      overflow: auto;

      font-size: 1.2em;
      padding: 12px;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
